/**
 * Parallelo di assertNever, ma senza errori.
 * In questo modo è possibile assicurarsi che gli switch siano esaustivi
 * ma l'errore viene visualizzato a livello di typescript e non a runtime.
 * @param _: valore che non dovrebbe mai essere raggiunto
 */
export function checkNever(_: never) {
  return;
}
